import React from 'react';
import Icon from '../assets/img/triangle.png';
import { FilterArchive } from '../models/card';

interface DropdownState {
    isShow?: boolean;
    selectData?: string;
    dropdownList?: any[];
}

interface DropdownProps {
    setData?: any;
    className?: string;
    type?: string;
    setFilter?: Function;
    filter: FilterArchive;
}

class Dropdown extends React.PureComponent<DropdownProps, DropdownState> {
    private wrapperRef: any;
    constructor(props: any) {
        super(props);
        this.state = { isShow: false, selectData: 'Sort by: Latest Activity', dropdownList: ['Latest Activity', 'Volume', 'Submitted Date', 'Topic Name'] };
        this.wrapperRef = React.createRef();
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside = (event: any) => {
        const {isShow} = this.state;
        if (this.wrapperRef && !this.wrapperRef.current.contains(event.target) && isShow) {
            this.setState({ isShow: false });
        }
    }

    openDropDown = () => {
        const { isShow } = this.state;
        this.setState({ isShow: !isShow });
    }

    setDefaultData = (value: string) => {

        this.setState({ selectData: `Sort by: ${value}`, isShow: false });
        const filter = {...this.props.filter};
        filter.sortBy = value;
        this.props?.setFilter && this.props.setFilter(filter, 'sortBy');
    }
    render() {
        const { isShow, dropdownList, selectData } = this.state;
        const dataList = dropdownList && dropdownList.map((data: any, index: number) => (<div onClick={() => { this.setDefaultData(data) }} style={{ padding: '10px' }} key={index} >{data}</div>));
        return (<React.Fragment>
            <div className={`${this.props.className}`} >
                <div ref={this.wrapperRef} className={`dropdown-container`} >
                    <div onClick={() => { this.openDropDown() }} style={{ border: 'none', width: '270px' }} className="dropdown-select">
                        {selectData} <span><img src={Icon} alt='logo-e' /> </span>
                    </div>
                    {
                        isShow &&
                        (<div className="dropdown-container-list content" style={{ marginTop: '10px', border: '1px solid black', position: 'absolute', zIndex: 99, width: '100%',maxHeight:'250px', backgroundColor: 'white' }}>
                            {dataList}
                        </div>)
                    }
                </div>
            </div>
        </React.Fragment>
        );
    }
}

export default Dropdown;